import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormType } from '../../backend/openapi/api-types';
import { SearchParam } from '../../../core/routing/param';
import { useSearchParam } from '../../../core/routing/hooks/use-search-param';
import { AuthenticatedForm } from './authenticated-form';

export const NewUserForExistingCustomer: React.FC = () => {
  const { t } = useTranslation();
  const { companyName } = useSearchParam([SearchParam.companyName]);
  const queryParam = companyName ? { companyName } : undefined;

  return (
    <AuthenticatedForm
      documentTitle={t('form.createNewUserForExistingCustomer.documentTitle')}
      formType={FormType.createNewUserForExistingCustomer}
      queryParam={queryParam}
    />
  );
};
